module.exports = __webpack_public_path__ + "assets/img/diamond.a6b395f5.png";